"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetManager = void 0;
var asset_model_1 = require("./asset.model");
var assetLoader_1 = require("./assetLoader");
var realms_three_1 = __importDefault(require("realms-three"));
var threeClone_1 = require("./threeClone");
var AssetManager = /** @class */ (function () {
    function AssetManager(assetMap) {
        this.assetMap = assetMap;
        this.loader = new assetLoader_1.AssetLoader();
        this.loadedObjects = new Map();
        this.loadedTextures = new Map();
    }
    /*
     * Checks whether the given asset exists
     */
    AssetManager.prototype.isValidAsset = function (name) {
        return this.assetMap[name] !== undefined;
    };
    /*
     * Gets a give object
     */
    AssetManager.prototype.getObject3D = function (name, options) {
        if (options === void 0) { options = {}; }
        var obj = this.loadedObjects.get(name);
        if (obj === undefined) {
            throw new Error("Asset ".concat(name, " is not a defined object"));
        }
        return (0, threeClone_1.threeClone)(obj, options);
    };
    /*
     * Same as getObject3D but ensures that it is a mesh
     */
    AssetManager.prototype.getMesh = function (name, options) {
        if (options === void 0) { options = {}; }
        var mesh = this.getObject3D(name, options);
        if (!(mesh instanceof realms_three_1.default.Mesh)) {
            throw new Error("Asset ".concat(name, " is not a mesh"));
        }
        return mesh;
    };
    /*
     * Gets a given texture
     */
    AssetManager.prototype.getTexture = function (name, options) {
        if (options === void 0) { options = {}; }
        var texture = this.loadedTextures.get(name);
        if (texture === undefined) {
            throw new Error("Asset ".concat(name, " is not a defined texture"));
        }
        if (options.clone) {
            texture = texture.clone();
        }
        return texture;
    };
    /*
     * Returns if all assets have loaded
     */
    AssetManager.prototype.hasLoaded = function () {
        var _this = this;
        return Object.entries(this.assetMap).every(function (_a) {
            var assetName = _a[0], config = _a[1];
            var fileExt = (0, asset_model_1.getAssetFileExtension)(config.fileName);
            switch (fileExt) {
                case asset_model_1.AssetFileType.FBX:
                    return _this.loadedObjects.has(assetName);
                case asset_model_1.AssetFileType.PNG:
                    return _this.loadedTextures.has(assetName);
                case asset_model_1.AssetFileType.JPG:
                    return _this.loadedTextures.has(assetName);
                case asset_model_1.AssetFileType.GLTF:
                    return _this.loadedObjects.has(assetName);
            }
        });
    };
    /*
     * Loads the assets inside the assetMap
     */
    AssetManager.prototype.loadAssets = function (loadingCallback, onFinish) {
        return __awaiter(this, void 0, void 0, function () {
            var assetsLoaded, assetsToLoad;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetsLoaded = 0;
                        assetsToLoad = Object.keys(this.assetMap).filter(function (assetName) { return !_this.loadedObjects.has(assetName); });
                        return [4 /*yield*/, Promise.all(assetsToLoad.map(function (assetName) { return __awaiter(_this, void 0, void 0, function () {
                                var config, loadedAsset, e_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            config = this.assetMap[assetName];
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this.loader.load(config)];
                                        case 2:
                                            loadedAsset = _a.sent();
                                            if (loadedAsset instanceof realms_three_1.default.Object3D) {
                                                if (config.unwrap) {
                                                    if (loadedAsset.children.length === 0) {
                                                        throw new Error("Cannot unwrap an asset with no children. Asset: ".concat(assetName));
                                                    }
                                                    loadedAsset = loadedAsset.children[0];
                                                }
                                                if (config.scale !== undefined) {
                                                    loadedAsset.scale.setScalar(config.scale);
                                                }
                                                if (config.quaternion !== undefined) {
                                                    loadedAsset.quaternion.set(config.quaternion.x, config.quaternion.y, config.quaternion.z, config.quaternion.w);
                                                }
                                                this.loadedObjects.set(assetName, loadedAsset);
                                            }
                                            else if (loadedAsset instanceof realms_three_1.default.Texture) {
                                                this.loadedTextures.set(assetName, loadedAsset);
                                            }
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_1 = _a.sent();
                                            console.error("Failed to load ".concat(assetName));
                                            console.error(e_1);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            assetsLoaded += 1;
                                            if (loadingCallback) {
                                                loadingCallback({
                                                    assetsLoaded: assetsLoaded,
                                                    assetsToLoad: assetsToLoad.length,
                                                });
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        onFinish === null || onFinish === void 0 ? void 0 : onFinish();
                        return [2 /*return*/];
                }
            });
        });
    };
    return AssetManager;
}());
exports.AssetManager = AssetManager;
